/*
 * @Author: songjingyang songjingyang@meishubao.com
 * @Date: 2025-03-28 15:40:04
 * @LastEditors: songjingyang songjingyang@meishubao.com
 * @LastEditTime: 2025-03-28 15:40:39
 * @FilePath: src/utils/dynamicTitle.ts
 * @Description: TypeScript版本 - 自动转换
 */

import useSettingsStore from '@/store/modules/settings'
import { translate } from '@/locales/route'

/**
 * 动态修改标题
 */
export function useDynamicTitle(): any {
  const settingsStore = useSettingsStore();
  const appTitle = translate('app.title');
  if (settingsStore.dynamicTitle) {
    document.title = settingsStore.title + ' - ' + appTitle;
  } else {
    document.title = appTitle;
  }
}